import {
  createListenerMiddleware,
  TypedStartListening,
} from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '..';

export const listenerMiddleware = createListenerMiddleware();

type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening = listenerMiddleware.startListening as AppStartListening;
